"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.goScenario_crokinole = exports.goGame = exports.goMenuMain = exports.goLoading = exports.update = exports.addAfterLoad = exports.networkPause = exports.togglePause = exports.get = void 0;
var common_sidecar_1 = require("@main/common-sidecar");
var gameMode_scenario_crokinole_sidecar_1 = require("./gameMode_scenario_crokinole-sidecar");
var crokinoleTestParams_sidecar_1 = require("./crokinoleTestParams-sidecar");
var crokinoleUi_menu_main_sidecar_1 = require("@crokinole/ui-menus/crokinoleUi_menu_main-sidecar");
var crokinoleGameManager_sidecar_1 = require("./crokinoleGameManager-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
    }
    return _obj;
}
exports.get = get;
function togglePause() {
    // voyageMessageGeneralCommand.sendMessageAndImmediatelyExecute({
    //   command: get().isPaused ? EGeneralCommand.Unpause : EGeneralCommand.Pause,
    // })
}
exports.togglePause = togglePause;
function networkPause(isPaused) {
    get().isPaused = isPaused;
}
exports.networkPause = networkPause;
function create() {
    var obj = {
        generator: null,
        generator_exit: null,
        generatorPauseSeconds: 0,
        isPaused: false,
        mode: 'init',
        afterLoad: [],
    };
    return obj;
}
function addAfterLoad(action) {
    var obj = get();
    obj.afterLoad.push(action);
}
exports.addAfterLoad = addAfterLoad;
function update() {
    var obj = get();
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    if (obj.generatorPauseSeconds > 0) {
        obj.generatorPauseSeconds -= ds;
        return;
    }
    if (obj.generator) {
        var generatorResult = obj.generator.next();
        if (generatorResult.done) {
            // console.log('voyageGameManager', 'Generator is done!')
            // obj.generator = null
        }
        else {
            obj.generatorPauseSeconds = generatorResult.value;
        }
    }
}
exports.update = update;
function switchMode(newMode, generator, generatorExit) {
    if (generatorExit === void 0) { generatorExit = function () { }; }
    var obj = get();
    exitCurrentMode();
    obj.mode = newMode;
    obj.generator = generator;
    obj.generator_exit = generatorExit;
}
function exitCurrentMode() {
    var obj = get();
    if (obj.generator_exit) {
        obj.generator_exit();
        obj.generator_exit = null;
    }
}
function goLoading() {
    // switchMode('loading', voyageGameMode_loading.generator_loading())
    var tm = crokinoleTestParams_sidecar_1.crokinoleTestParams.testMode;
    if (tm === 'mp-test') {
        crokinoleUi_menu_main_sidecar_1.crokinoleUi_menu_main.setOpen('in-game');
        crokinoleGameManager_sidecar_1.crokinoleGameManager.goScenario_crokinole();
    }
}
exports.goLoading = goLoading;
function goMenuMain() {
    // switchMode('main-menu', voyageGameMode_menuMain.generator_menuMain())
}
exports.goMenuMain = goMenuMain;
function goGame() {
    // switchMode('game', voyageGameMode_game.generator_game())
}
exports.goGame = goGame;
// TODO: change this?
function goScenario_crokinole() {
    switchMode('test-mp', gameMode_scenario_crokinole_sidecar_1.gameMode_scenario_crokinole.generator_crokinole());
}
exports.goScenario_crokinole = goScenario_crokinole;
